jQuery(function($) {
  var equalize = function() {
    var groups = {};
    $('[data-equalize]').each(function() {
      var $this = $(this);
      var group = $this.attr('data-equalize');
      if(groups[group]) {
        groups[group] = groups[group].add($this);
      } else {
        groups[group] = $this;
      }
    });
    Object.keys(groups).forEach(function(group) {
      groups[group].css({ height: 'auto' });
      var maxHeight = groups[group].toArray().map($).reduce(function(height, $elm) { return Math.max(height, $elm.height()); }, 0);
      groups[group].each(function() {
        var $this = $(this);
        var breakpoint = $this.attr('data-equalize-breakpoint');
        if(!breakpoint || window.currentBreakpoint.includes(breakpoint)) {
          $this.height(maxHeight);
        }
      });
    });
  };
  $(window).on('resize', debounce(equalize, 200));
  setTimeout(equalize, 250);
});